import { AfterContentChecked, ChangeDetectorRef, Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[appComponentResize]'
})
export class ComponentResizeDirective implements AfterContentChecked {

  constructor(
    private el: ElementRef,
    private cdr: ChangeDetectorRef
  ) { }

  public ngAfterContentChecked(): void {
    this.resize();
  }

	@HostListener("window:resize", ["$event"])
	public onResize(): void {
    this.resize();
	}

  private resize(): void {
    this.el.nativeElement?.offsetWidth;
    // TODO
  }
}
